define('ordersDetailMessagesFooterView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'imageUtils',
  'textAreaView',
  'buttonView',
  'checkboxView',
  'ordersDetailMessagesFooterAttachmentsView',
  'template!ordersDetailMessagesFooterView',
  'entities/customers/messages'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  ImageUtils,
  TextArea,
  ButtonView,
  CheckboxView,
  AttachmentsView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'footer-view',

    ui: {
      attachmentInput: '.attachment-input'
    },

    events: {
      'change @ui.attachmentInput' : 'onAddAttachment'
    },

    regions: {
      messageArea: '.message-region',
      sendButtonRegion: '.send-button-region', 
      attachmentButtonRegion: '.attachment-button-region',
      actionRequiredInernalRegion: '.action-required-internal-region',
      actionRequiredUkrRegion: '.action-required-ukr-region',
      attachmentsRegion: '.attachments-region'
    },

    serializeData: function() {
      var data = {};        
      return data;
    },

    onRender: function () {
      this.messageView = new TextArea({
        onEnter: _.bind(this.onSend, this),
        onKeyDown: _.bind(this.onMessageChange, this),
        onInput: _.bind(this.onMessageChange, this)
      });
      this.getRegion('messageArea').show(this.messageView);

      //---------------------------
      this.sendButtonView = new ButtonView({
        type: 'send-mail',
        color: 'orange'
      });
      this.getRegion('sendButtonRegion').show(this.sendButtonView);
      this.sendButtonView.on('click', _.bind(this.onSend, this));
      this.sendButtonView.enabled(false);

      //---------------------------
      this.attachmentButtonView = new ButtonView({
        type: 'attachment',
        color: 'lightgrey'
      });
      this.getRegion('attachmentButtonRegion').show(this.attachmentButtonView);
      this.attachmentButtonView.on('click', _.bind(this.onSelectAttachment, this));
     
      //---------------------------
      this.actionRequiredInernalView = new CheckboxView({
          text: _.i18n('orders.actionRequired'),
          value: this.model.get('order').get('actionRequiredInternal'),
          onChange: _.bind(function (value) {
            var defer = $.Deferred();         
            App.request('order:update', {
              purchaseOrderId: this.model.get('poi'),
              actionRequiredInternal: value
            }).done(_.bind(function () {
              this.model.get('order').fetch().done(_.bind(function () {
                this.actionRequiredInernalView.setValue(value);
                defer.resolve();
              }, this));              
            }, this)).fail(_.bind(function () {
              this.model.get('order').fetch();
              defer.reject();
            }, this));
            return defer.promise();
          }, this)
        });
        this.actionRequiredInernalRegion.show(this.actionRequiredInernalView);

      //---------------------------
      this.actionRequiredUkrView = new CheckboxView({
          text: _.i18n('orders.actionRequiredUkr'),
          value: this.model.get('order').get('actionRequiredUkr'),
          onChange: _.bind(function (value) {
            var defer = $.Deferred();         
            App.request('order:update', {
              purchaseOrderId: this.model.get('poi'),
              actionRequiredUkr: value
            }).done(_.bind(function () {
              this.model.get('order').fetch().done(_.bind(function () {
                this.actionRequiredUkrView.setValue(value);
                defer.resolve();
              }, this));              
            }, this)).fail(_.bind(function () {
              this.model.get('order').fetch();
              defer.reject();
            }, this));
            return defer.promise();
          }, this)
        });
        this.actionRequiredUkrRegion.show(this.actionRequiredUkrView);

        //---------------------------
        this.attachmentsView = new AttachmentsView();
        this.getRegion('attachmentsRegion').show(this.attachmentsView);
    },

    onMessageChange: function () {
      if(this.messageView.getValue() === '') {
        this.sendButtonView.enabled(false);
      } else {
        this.sendButtonView.enabled(true);
      } 
    },

    onSend: function () {   
      if(!this.options.parentView.ticket)
        return;

      if(this.messageView.getValue() === '')
        return;     

      var model = new Backbone.Model();
      model.set('content', this.messageView.getValue());
      model.set('name', this.options.parentView.ticket.name || ' ');
      model.set('files', this.attachmentsView.collection.toJSON());
      
      App.request('commandtickets:save-message', this.options.parentView.ticket.secId, model, true).done(_.bind(function (message) {
        var model = App.request('customer:message:model', {
          attachments: message.attachements || [],
          secId: message.secId,
          msgDate: message.date,
          userpid: message.userPid,
          content: message.content
        });        
        
        this.options.parentView.view.collection.add(model);

        this.triggerMethod('scrooltop');      
        this.attachmentsView.collection.reset();  
      }, this));

      this.sendButtonView.enabled(false);
      this.messageView.setValue('');
    },

    onSelectAttachment: function () {
      this.ui.attachmentInput.click();      
    },

    onAddAttachment: function (e) {         
      var promises = [];

      _.each(e.target.files, _.bind(function (file) {
        promises.push(_.bind(function () {
          return new Promise(_.bind(function(resolve) {
            this.encodeFileToBase64(file).then(_.bind(function (file, data) {     
              var model = new Backbone.Model({
                name: file.name,               
                extension: file.name.substring(file.name.lastIndexOf('.')),
                content: data
              });
          
              this.attachmentsView.collection.add(model);   
              this.attachmentsView.setVisibility();      
              resolve();
            }, this)).fail(_.bind(function () {
              resolve();
            }, this));
          }, this));
        }, this));
      }, this));

      promises.reduce(function (previousPromise, currentFunction) {
        return previousPromise.then(currentFunction);
      }, Promise.resolve());
    },

    encodeFileToBase64: function (file) {
      var defer = $.Deferred();
      var reader = new FileReader();

      reader.onloadend = function () {
        defer.resolve(file, btoa(ImageUtils.ab2str(reader.result)));
      };

      reader.onerror = function () {
        defer.reject('Error reading file');
      };
        
      reader.readAsArrayBuffer(file); 
      return defer.promise();
    }
  });
});
